import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { ProductService } from "src/app/components/shared/services/product.service";
import { Router } from "@angular/router";
import { ColorFilter } from "src/app/modals/product.model";
import { FormGroup } from "@angular/forms";
import { ConfigService } from "src/app/components/shared/services/config.service";
import { DSProduct } from "src/app/modals/dsproduct.modal";
import { UtilityService } from "src/app/components/shared/services/utility.service";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import * as _ from "lodash";
import { ItemsListService } from "src/app/components/shared/services/itemsList.service";
import { CompanyService } from "src/app/components/shared/services/company.service";
import { Cart1Service } from "src/app/components/shared/services/cart1.service";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { DialogforproductComponent } from "../../shared/dialogforproduct/dialogforproduct.component";
import { LoaderService } from "../../shared/services/loader.service";
import { UserService } from "../../shared/services/user.service";
import { RestApiService } from "../../shared/services/restapi.service";
import { CORPORATESTOREID, DefaultCountry, RETAILSTOREID } from "src/app/constant";

@Component({
  selector: "app-brainmoodandenergy",
  templateUrl: "./brain-mood-and-energy.component.html",
  styleUrls: ["./brain-mood-and-energy.component.scss"],
})
export class BrainMoodAndEnergyComponent implements OnInit {
  variableBrowse = false;
  public product: any = {};
  displayProductList: any;
  displayForCarousel = [
    {
      img: "../../../../assets/images/new/banner-4.jpg",
      startext:
        "Super products, especially now when we need to keep our immune system strong!",
      author: "Dr. Karl Anderson",
      location: "Meridian, ID",
      small: false,
      medium: true,
      left: false,
      leftbig: true,
      boxTitle: "QUALITY PRODUCTS",
      boxContent: "All Natural Ingredients for Your Health Goals",
    },
  ];
  env: any;
  searchFormGroup: FormGroup;
  categoryTypeGroup: FormGroup;
  sortByFormGroup: FormGroup;
  productSearchText: string = "";
  public sidenavOpen: boolean = true;
  public animation: any; // Animation
  public sortByOrder: any; // sorting
  public page: any;
  public tagsFilters: any[] = [];
  public viewType: string = "grid";
  public viewCol: number = 34;
  public filterForm: FormGroup;
  public colorFilters: ColorFilter[] = [];
  public searchProduct: any;
  public items: Array<DSProduct> = [];
  public products: Array<DSProduct> = [];
  public CustomMadeItemArray: Array<DSProduct> = [];
  public allItems: { Category: any; CategoryId: any }[] = [];
  public featuredCollection: Array<DSProduct> = [];
  public tags: any[] = [];
  public colors: any[] = [];
  customCssCheckBox: any;
  Checkedall: boolean = false;
  Checkedmagnetic: boolean = false;
  CheckedwhatsHot: boolean = false;
  Checkedenrollment: boolean = false;
  Checkedlips: boolean = false;
  Checkedeyes: boolean = false;
  slides: Array<any> = [];
  sortKeys: Array<any> = [];
  selectedCategory: any = { Category: "all", CategoryId: '-1' };
  isAllunselect: boolean;
  regularDistribution = 100 / 3 + "%";
  RegionIDForRequest: any;
  selectedCategoryId: any = '-1';
  isSidebarFixed: any = 0;
  storeId:any;
  pageTitle: string = '';
  routeTitleMap: { [key: string]: string } = {
    'brain-mood-and-energy': 'Brain, Mood and Energy',
    'essential-oils': 'Essential Oils',
    'immune-and-cardiovascular': 'Immune & Cardiovascular',
    'men-and-womens-health': "Men's & Women's Health",
    'muscle-bone-and-joint': 'Muscle, Bone, & Joint',
    'skin-and-beauty': 'Skin & Beauty',
  };

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private productService: ProductService,
    public configService: ConfigService,
    public utilityService: UtilityService,
    public itemsListService: ItemsListService,
    public companyService: CompanyService,
    public cart1Service: Cart1Service,
    public router: Router,
    public dialog: MatDialog,
    private loader: LoaderService,
    public userService: UserService,
    private apiService: RestApiService
  ) {
    this.setPageTitle();
  }

  public OrderQuantityCount: any;
  showNoProductsError: boolean = false;
  showIsLoading: boolean = true;

  ngOnInit() {
    if(this.router.url == '/essential-oils') {
      this.selectedCategory.CategoryId = '21';
    }else if(this.router.url == '/brain-mood-and-energy') {
      this.selectedCategory.CategoryId = '17';
    }else if(this.router.url == '/immune-and-cardiovascular') {
      this.selectedCategory.CategoryId = '14';
    }else if(this.router.url == '/men-and-womens-health') {
      this.selectedCategory.CategoryId = '16';
    }else if(this.router.url == '/muscle-bone-and-joint') {
      this.selectedCategory.CategoryId = '15';
    }else if(this.router.url == '/skin-and-beauty') {
      this.selectedCategory.CategoryId = '12';
    }
    window.scrollTo(0, 0);
    let a = sessionStorage.getItem('selectedCountry');
    this.configService.getCommonSetting(a, sessionStorage.getItem('SelectedLanguage')).then(() => {
      this.userService.userServiceModal.selectedCountry = a
      this.RegionIDForRequest = this.companyService.getRegionID(a || this.userService.userServiceModal?.selectedCountry || DefaultCountry)
      this.getAllProductItems(this.RegionIDForRequest);
    });
    //somtimes common setting loaded in time then items are called otherwise no items called
    // this.getstoreId();
    this.sortByOrder = this.utilityService.getSortKey()[6];
    this.translate.get("global_Company_Title").subscribe((text: string) => {
      this.titleService.setTitle(
        this.translate.instant("pagetitle_product") + " | " + text
      );
    });

    this.loader.isLoading.subscribe((v) => {
      this.showIsLoading = v;
      if (v == false) {
        this.showNoProductsError = true;
      }
    });
  }
  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   this.onscreenchange();
  //   const sidebarOffset = 300;
  //   const scrollPosition = window.pageYOffset;
  //   const shopNowSection = document.querySelector('.shopNowSection');
  //   const sidebarfixLife = document.querySelector('.fix-Sidebar')

  //   // if(svgcomponent) {731
  //   //   this.isSidebarFixed = 2;
  //   // }
  //   if (shopNowSection) {
  //     const shopNowSectionBottom = shopNowSection.getBoundingClientRect().bottom;
  //     const sidebarfix = sidebarfixLife.getBoundingClientRect().bottom;
  //     if (scrollPosition > sidebarOffset && screen.width > 768 && scrollPosition < (shopNowSectionBottom + scrollPosition - 700)) {
  //       this.isSidebarFixed = 1;
  //     }
  //     else if (scrollPosition > sidebarOffset && screen.width > 768 && scrollPosition >= (sidebarfix - 300)) {
  //       this.isSidebarFixed = 2;
  //       console.log("this.isSidebarFixed", this.isSidebarFixed)
  //     }
  //     else {
  //       this.isSidebarFixed = 0;
  //       console.log("this.isSidebarFixed", this.isSidebarFixed)

  //     }
  //   }
  // }
  compareObjects(o1: any, o2: any): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }

  // sorting type ASC / DESC / A-Z / Z-A etc.
  onChangeSorting($event) {
    this.sortByOrder = $event.value;
  }

  public onPageChanged(event) {
    this.page = event;
    window.scrollTo(0, 0);
  }


  onChange(selectedCategory) {
    this.displayProductList = [];
    if (selectedCategory == 'all') {
      this.displayProductList = this.products;
    }
    else {
      this.displayProductList = this.products.filter(product => product.CategoryId === selectedCategory).sort((a, b) => a.Category.localeCompare(b.Category)).slice(0, 9);
    }
    this.selectedCategoryId = selectedCategory;
  }

  mouseEnter(index) {
    if (screen.width > 960) {
      document.getElementById("btn" + index).classList.add("faded-in");
      document.getElementById("btn" + index).classList.remove("faded-out");
      setTimeout(() => {
        document.getElementById("btn" + index).style.opacity = "1";
      }, 590);
    }
  }
  mouseOut(index) {
    if (screen.width > 960) {
      document.getElementById("btn" + index).classList.add("faded-out");
      setTimeout(() => {
        document.getElementById("btn" + index).style.opacity = "0";
      }, 590);
      document.getElementById("btn" + index).classList.remove("faded-in");
    }
  }
  increaseQuantiy(type, item) {
    this.cart1Service.increaseQuantiy(item, type == "autoship", type == "pack");
  }

  getAllProductItems(RegionID?) {
    this.storeId = this.isLoggedIn() ? (this.userService.userServiceModal?.customerData?.IsCorporate == true ?  CORPORATESTOREID : RETAILSTOREID) : RETAILSTOREID;
    const request = {
      RegionID: RegionID || 1,
      CategoryId: "all",
      StoreID: this.storeId
    };
    //main request for api calling
    this.productService.getProductByCategory(request).subscribe((products) => {
      this.productService.orders = products.map((item) => {
        item.Price = item.Price || (item.Prices && item.Prices[0] && item.Prices[0].Price);
        return item;
      });

      //filling unique products according to category
      const uniqueRequireProduct = ([] = _.uniqBy(products, (x) => x.CategoryId));

      //selected category data filling
      this.itemsListService.selectedCategories = {};
      if (this.selectedCategory?.CategoryId == "all") {
        this.itemsListService.selectedCategories["all"] = true;
      }
      //itemlistservice categorylist data filling
      this.itemsListService.categoryList = _.map(uniqueRequireProduct, (object) => { return _.pick(object, ["CategoryId", "Category"]); });

      //empty product array
      this.products = [];

      const product = (this.displayProductList = this.productService.orders);

      product.filter((x) => {
        if (x.Category) {
          this.products.push(x);
        }
      });
      //filling products here in the html use to display products
      this.onChange(this.selectedCategory?.CategoryId);
      this.itemsListService.type = "order";

      //displaying according to category
      var category;
      this.itemsListService.categoryList.filter((x) => {
        if (x.CategoryId == this.selectedCategory.CategoryId) {
          category = x.Category;
        }
      });
      if (this.selectedCategory.CategoryId == "all") {
        this.itemsListService.getItemsByCategory("all");
      } else {
        this.itemsListService.getItemsByCategory(category);
      }
    });
    this.env = environment;
  }

  goToShop(id) {
    let prodId = id;
    let proddata = {};

    this.productService.getProduct(prodId).subscribe((product) => {
      proddata = this.product;
      this.product = product ? [product] : [];
      this.productService.selectedOrderItems.filter((x) => {
        if (x.ItemID == this.product[0].ItemID) {
          this.product.Quantity = x.Quantity;
        }
      });

      if (this.product.length) {
        const dialogRef = this.dialog.open(DialogforproductComponent, {
          data: {
            product: this.product,
            productList: this.products,
          },
          maxHeight: "600px",
        });
        dialogRef.afterClosed().subscribe((dialogresult) => {
          if (true) {
            this.router.navigate(["/shop"]);
            this.itemsListService.getItemsByCategory(this.itemsListService.selectedCategories);
          }
        });
      }
      this.OrderQuantityCount =
        product && product.Quantity ? product.Quantity : 1;
    });
  }

  browsefunc(CategoryId) {
    this.selectedCategory = { CategoryId: CategoryId };

    this.productService.orders = this.products.map((item) => {
      item.Price =
        item.Price ||
        (item.Prices && item.Prices[0] && item.Prices[0].Price);
      return item;
    });
    const uniqueRequireProduct = ([] = _.uniqBy(
      this.products,
      (x) => x.CategoryId
    ));

    this.itemsListService.selectedCategories = {};


    if (this.selectedCategory.CategoryId == "all") {
      this.itemsListService.selectedCategories["all"] = true;
    }

    this.itemsListService.categoryList = _.map(
      uniqueRequireProduct,
      (object) => {
        return _.pick(object, ["CategoryId", "Category"]);
      }
    );

    this.products = [];
    const product = (this.itemsListService.products =
      this.productService.orders);
    product.filter((x) => {
      if (x.Category) {
        this.products.push(x);
      }
    });
    this.itemsListService.products = this.products;
    this.itemsListService.type = "order";
    var category;
    this.itemsListService.categoryList.filter((x) => {
      if (x.CategoryId == this.selectedCategory.CategoryId) {
        category = x.Category;
      }
    });
    if (this.selectedCategory.CategoryId == "all") {
      this.itemsListService.getItemsByCategory("all");
    } else {
      this.itemsListService.getItemsByCategory(category);
    }


    this.slides = this.configService.localSettings.Product.PrimaryBanner;

    this.sortKeys = this.utilityService.getSortKey();
    this.env = environment;
  }
  leftPosition = '0%';
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const width = event.target.innerWidth;
    if (width < 992) {
      this.leftPosition = '0%';
    }
    else if (width > 992 && width < 1400) {
      this.leftPosition = '0%';
    } else if (width > 1401 && width < 1599) {
      this.leftPosition = '4.2%';
    }else if(width > 1600 && width < 1799){
      this.leftPosition = '7.2%';

    }
    else if (width > 1800 && width<2000) {
      this.leftPosition = '16%';
    }else{
      this.leftPosition = '19%';

    }
    // if (width > 1920) {
    //   this.leftPosition = '18%';
    // } else if (width > 1600) {
    //   this.leftPosition = '10%';
    // } else if (width > 1440) {
    //   //this.leftPosition = '7%';
    // }  else if (width > 1024) {
    //   this.leftPosition = '2%';
    // }
    // else {
    //   this.leftPosition = '3.6%';
    // }
  }
  navigateproductDetail(data: any) {
    const formattedProductUrl = `${data.ProductName.replace(/\s+/g, '-').toLowerCase()}-id${data.ItemID}`;
    this.router.navigate(['/product'], { queryParams: { id: formattedProductUrl } });
    // this.router.navigate(['/product'], { queryParams: { id: data.ItemID } });
  }

  setPageTitle() {
    this.router.events.subscribe(() => {
      const currentRoute = this.router.url.split('/').pop(); // Get the last segment of the URL
      this.pageTitle = this.routeTitleMap[currentRoute] || ''; // Set title based on mapping
    });
  }

  // @ViewChild('CategoryBoxScroll') CategoryBoxScroll!: ElementRef<HTMLDivElement>;
  // isOverflow = false;
  // checkOverflow(): void {
  //   const element = this.CategoryBoxScroll.nativeElement;
  //   const maxHeight = 30 * 16;
  //   this.isOverflow = element.scrollHeight > maxHeight;
  // }
  // onscreenchange(): void {
  //   this.checkOverflow();
  // }
  isLoggedIn(): boolean{
    let isLoggedIn = false;
    this.apiService.loginStatus.subscribe(val => {
      isLoggedIn =  val;
    });
    return isLoggedIn;
  }
}
